// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7178ee6a","488":"20d70352","977":"1e874720"}[chunkId] + ".chunk.js";
};